import { exclusionContract } from "@clipboard-health/contract-backend-main";
import { useGetParsedQuery } from "@src/appV2/api/useGetParsedQuery";
import { environmentConfig } from "@src/appV2/environment";
import { APP_V2_APP_EVENTS } from "@src/appV2/lib/analytics";
import { type UseQueryResult } from "@tanstack/react-query";
import { type z } from "zod";

export const GET_EXCLUSIONS_META_URL = `${environmentConfig.REACT_APP_BASE_API_URL}/exclusion/meta`;

export type GetExclusionsMetaQuery = z.input<typeof exclusionContract.countDocuments.query>;
export type GetExclusionsMetaResponse = z.output<
  (typeof exclusionContract.countDocuments.responses)[200]
>;

export interface UseGetExclusionsMetaParams extends GetExclusionsMetaQuery {
  enabled?: boolean;
}

export type UseGetExclusionsMetaResult = UseQueryResult<GetExclusionsMetaResponse>;

export function useGetExclusionsMeta(
  params: UseGetExclusionsMetaParams
): UseGetExclusionsMetaResult {
  const { facilityId, agentId, enabled = true } = params;

  return useGetParsedQuery({
    url: GET_EXCLUSIONS_META_URL,
    queryParams: { facilityId, agentId },
    queryParamsSchema: exclusionContract.countDocuments.query,
    responseSchema: exclusionContract.countDocuments.responses[200],
    enabled,
    meta: {
      logErrorMessage: APP_V2_APP_EVENTS.GET_EXCLUSIONS_META_FAILURE,
    },
  });
}
